import React from 'react';
import { Link } from 'react-router-dom';

/**
 * The band every page closes on. It carries its own photograph and a hard edge
 * along the bottom: without them it shared a ground with the footer directly
 * beneath, and the page appeared to end twice.
 */
const CtaBand = ({ title, image, children, action = 'Book a demo', to = '/demo' }) => (
  <section className="stms-close">
    <div
      className="stms-close__art"
      style={{ backgroundImage: `url(${image})` }}
      aria-hidden="true"
    />
    <div className="stms-wrap">
      <div className="stms-close__say">
        <h2>{title}</h2>
        {children}
        <Link className="stms-btn stms-btn--solid stms-btn--lg" to={to}>{action}</Link>
      </div>
    </div>
  </section>
);

export default CtaBand;
